import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useToast } from '../hooks/use-toast';

// Redirige les anciennes URLs mock (/webtoons, /webtoon/:id, /read/:id, /actualites, /artistes)
// vers le vrai catalogue, avec un message discret. Aucune fausse fiche, aucun faux lecteur.
const LegacyRedirect = () => {
  const { toast } = useToast();
  useEffect(() => {
    toast({
      title: 'Page indisponible',
      description: 'Cette page n’est plus disponible. Découvrez le catalogue Citytoon.',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Navigate to="/catalogue" replace />;
};

export default LegacyRedirect;
